import { z } from "zod/v4";

export const brandNameSchema = z.object({
  id: z.number(),
  name: z.string(),
});

export type BrandName = z.infer<typeof brandNameSchema>;
